import http from './http';

export const getById = (supervisorId) =>
  http.get(`/supervisor/${supervisorId}`).then((res) => res.data);
